(function(){
  function loadDeferredList(){
    var list = window.lmaPerformanceDeferredScripts || [];
    for (var i = 0; i < list.length; i++){
      var item = list[i] || {};
      var url = item.url || item.src || '';
      if (!url) continue;
      var already = document.querySelector('script[src="'+url+'"][data-lma-deferred="true"]');
      if (already) continue;
      var s = document.createElement('script');
      s.async = true;
      s.setAttribute('data-lma-deferred','true');
      s.src = url;
      document.body.appendChild(s);
    }
  }
  function dispatchFHLoad(){
    var e;
    try { e = new Event('fh_load'); }
    catch(_){ e = document.createEvent('Event'); e.initEvent('fh_load', true, true); }
    window.dispatchEvent(e);
  }
  function tuneGoogleFonts(){
    var links = document.querySelectorAll('link[rel="stylesheet"][href*="fonts.googleapis.com"]');
    links.forEach(function(l){
      var href = l.getAttribute('href') || '';
      if (!href) return;
      if (href.indexOf('display=swap') === -1){
        var sep = href.indexOf('?') === -1 ? '?' : '&';
        l.setAttribute('href', href + sep + 'display=swap');
      }
      if (l.media !== 'print'){
        l.media = 'print';
        l.onload = function(){ this.media = 'all'; };
      }
    });
  }
  function idleRun(){
    loadDeferredList();
    dispatchFHLoad();
    tuneGoogleFonts();
  }
  var runScheduled = false;
  function schedule(){
    if (runScheduled) return;
    runScheduled = true;
    if (window.requestIdleCallback) requestIdleCallback(idleRun, { timeout: 2500 });
    else setTimeout(idleRun, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
